import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf'

library.add(faFilePdf)

dom.watch()
